import { registerRumSubPage, registerRumUrl } from '@adv-frontend/rum-kit';
import type { Location } from '@direct-frontend/modules-router';
import { createBrowserHistory } from '@direct-frontend/modules-router/client';

const getLocationHref = ({ pathname, search, hash }: Location) => pathname + search + hash;

/**
 * Создаёт browser history с RUM-листенером для корректного измерения FCP при SPA-навигации.
 * Листенер вызывается синхронно до React-рендера, поэтому pageChangedTimestamp
 * выставляется раньше DOM-мутаций новой страницы.
 *
 * Навигации без смены URL (например, связь модальных окон с browser history через pushState/back) игнорируются,
 * чтобы не сбрасывать RUM-контекст.
 */
export function createRumHistory() {
    const history = createBrowserHistory();
    let lastHref = getLocationHref(history.location);

    history.listen(({ location }) => {
        const currentHref = getLocationHref(location);

        if (currentHref === lastHref) {
            return;
        }

        lastHref = currentHref;
        registerRumSubPage();
        registerRumUrl();
    });

    return history;
}
